<template>
  <div class="qyjs_box">

   <div>
	 <router-view></router-view>
   </div>
    <div class="box">
		<div class="boxA">
			<!-- <div class="search-t">
				<el-input  placeholder="请输入院校名称" v-model="queryParams.schoolName"  class="" clearable @keyup.enter.native="schGet">
					<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
				</el-input>
			</div> -->
			<el-form :model="queryParams" ref="queryForm" size="small" :inline="true" class="topsec" @submit.native.prevent>
				<el-row :gutter="24">
					<el-col :span="8">
						<el-form-item label="院校名称:" label-width="80px">
							<el-input  placeholder="请输入院校名称" v-model="queryParams.schoolName"  class="" clearable @keyup.enter.native="schGet" @clear="schGet">
								<!-- <el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button> -->
							</el-input>
							<div class="secList" v-if="queryParams.schoolName">
								<div class="secListli" :class="getschoolName=='schoolName'?'onseleSec':''" @click="gogo('schoolName')">搜索学校名称报考<span>{{queryParams.schoolName}}</span>的大学</div>
								<div class="secListli" :class="getschoolName=='majorNames'?'onseleSec':''" @click="gogo('majorNames')">搜索专业名称报考<span>{{queryParams.schoolName}}</span>的大学</div>
							</div>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="院校地区:" label-width="80px">
							<el-cascader @change='changCity' v-model='queryParams.citySchoolIds'
								:options="getcityArr" :props="defaultPropscity" collapse-tags
								popper-class="popperclass" clearable></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="选择专业:" label-width="80px">
							<el-cascader @change='changMajor' v-model='queryParams.majorCodeAlls'
								:options="getMajorArr" :props="defaultPropsmajor" collapse-tags
								popper-class="popperclass" clearable></el-cascader>
						</el-form-item>
					</el-col>
					
				</el-row>
				<!-- <el-row :gutter="24">
					<el-col :span="24">
						<el-form-item label="选择专业:" label-width="80px">
							<el-cascader @change='changMajor' v-model='queryParams.majorCodeAlls'
								:options="getMajorArr" :props="defaultPropsmajor" collapse-tags
								popper-class="popperclass" clearable></el-cascader>
						</el-form-item>
					</el-col>
				</el-row> -->
				 <el-row :gutter="28">
					<el-col :span="28">
						<el-form-item label="院校类型(多选):" label-width="120px">
							<div class="kuai">
								<!-- <span v-for="item in filtrate.A"   :class="queryParams.schoolType==item?'onsele':''" @click="clickB(item)">{{ item }}</span> -->
								<span v-for="item in filtrate.A"   :class="{onsele:queryParams.schoolType.includes(item)}" @click="clickB(item)">{{ item }}</span>
								
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			
				<el-row :gutter="28">
					<el-col :span="28" class="dataclass">
						<el-form-item label="办学性质(多选):" label-width="120px">
							<div class="kuai">
								<!-- <span v-for="item in filtrate.B"   :class="queryParams.natureName==item?'onsele':''" @click="clickC(item)">{{ item }}</span> -->
								<!-- <span v-for="item in filtrate.B"   :class="queryParams.natureName==item?'onsele':''" @click="clickC(item)">{{ item }}</span> -->
								
								<span v-for="item in filtrate.B"   :class="{onsele:queryParams.natureName.includes(item)}" @click="clickC(item)">{{ item }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
			
				<el-row :gutter="28">
					<el-col :span="28">
						<el-form-item label="院校层次(多选):" label-width="120px">
							<div class="kuai">
								<!-- <span v-for="item in filtrate.C"   :class="queryParams.attribute==item?'onsele':''" @click="clickD(item)">{{ item }}</span> -->
								<span v-for="item in filtrate.C"   :class="{onsele:queryParams.attribute.includes(item)}" @click="clickD(item)">{{ item }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-row :gutter="28">
					<el-col :span="28">
						<el-form-item label="不选条件(多选):" label-width="120px">
							<div class="kuai">
								<span v-for="item in filtrate.K" :class="{onsele:queryParams.notTtile.includes(item.titleName)}"  @click="xzCheckboxNotTtile(item)">{{ item.titleName }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="28" style="display: flex;justify-content: end;position: absolute;right: 0px;bottom: 0px;">
					<el-col :span="28">
						<el-form-item label="" label-width="80px">
							<div class="kuai">
								<el-button type="warning" size="medium"  class="elbu-vip" @click="yijianClick">
									<img style="margin-right: 10px;width: 20px; height: 14px" src="../../assets/img/vip.png" alt=""/>一键填报
								</el-button>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- 
				<el-row :gutter="28">
					<el-col :span="28">
						<el-form-item label="院校标签:" label-width="80px">
							<div class="kuai">
								<span v-for="item in filtrate.H" :class="(queryParams.oneJihuas==item.quer)||(queryParams.zuoyueJihuas==item.quer)||queryParams.youJihuas==item.quer?'onsele':''"  @click="clickF(item)">{{ item.name }}</span>
							</div>
						</el-form-item>
					</el-col>
				</el-row> -->
			</el-form>
		</div>
			<!-- 学校列表 -->
		<div class="schmain">
			<div class="box-tit" :class="{ sticky: isSticky }"><span :class="jihuaIndex==item.id?'onsele':''" v-for="(item,index) in filtrate.E" @click="navNum(item)">{{item.name}}({{item.num}})</span></div>
			<!-- v-if="schList&&schList.length" -->
			<div class="sch-ul" v-if="schList&&schList.length" ref="scrollContainer" v-intersect="handleIntersect">
				<!-- @click="goInfo(item)" -->
				<div class="sch-li" v-for="(item,index) in schList" v-if="(user.userVip==0&&index<=4)||(user.userVip>0)">
					<div class="schli-l">
						<div class="exaboxconli-l" @click="goInfo(item)">
							<img v-if="jihuaIndex==1" src="../../assets/img/chong1.png" alt="" />
							<img v-if="jihuaIndex==2" src="../../assets/img/chong2.png" alt="" />
							<img v-if="jihuaIndex==3" src="../../assets/img/chong3.png" alt="" />
							<!-- <div class="btitle">机会较大</div> -->
							<!-- <div v-if="jihuaIndex==1" class="bnum">60%</div>
							<div v-if="jihuaIndex==2" class="bnum">80%</div>
							<div v-if="jihuaIndex==3" class="bnum">90%</div> -->
							<div v-if="item.probability" class="bnum">{{item.probability}}</div>
						</div>
					</div>
					<div class="schli-r">
						<div class="schli-rt">
							<span class="schli-rt-a" @click="goInfo(item)">{{item.schoolName}}</span>
						</div>
						<div class="schli-rB">
							<span class="schli-rB-span" v-if="item.citySchoolName">{{item.citySchoolName}} | </span>
							<span class="schli-rB-span" v-if="item.natureName">{{item.natureName}}</span>
						</div>
						<div class="schli-rt">
							<span class="schli-rt-b" @click="goInfo(item)">{{item.majorName}}</span>
						</div>
						<div class="schli-rc">
							<div class="schli-rcA" v-if="item.branchs||item.rank">
								<span style="font-weight: 500;margin-right: 19px;">2026年</span>
							<!-- 	<span v-if="user.batchId==8001">预估分数/预估位次</span>
								<span v-else>分数/位次</span> -->
								<span >预估分数/预估位次</span>
								<span class="span1">{{item.branchs?item.branchs:'-'}}/{{item.rank?item.rank:'-'}}</span>
							</div>
							<div class="schli-rcA">
								<span>院校代码</span>
								<span class="span1">{{item.schoolCode?item.schoolCode:'-'}}</span>
							</div>
							<div class="schli-rcA">
								<span>专业代码</span>
								<span class="span1">{{item.majorCode?item.majorCode:'-'}}</span>
							</div>
							<div class="schli-rcA">
								<span>招生数量</span>
								<span class="span1">{{item.plan?item.plan:'-'}}</span>
							</div>
							<div class="schli-rcA" v-if="item.yearEdu||item.money">
								<span>学制/年学费</span>
								<span class="span1">{{item.yearEdu?item.yearEdu:'-'}}/{{item.money?item.money:'-'}}</span>
							</div>
							<div class="schli-rcA">
								<span>选科要求</span>
								<span class="span1">{{item.kemu?item.kemu:'-'}}</span>
							</div>
						</div>
						
						<div class="maindew">
							
							<div class="maindewli">
								<span v-if="item.planOne||(item.branchOnes&&item.branchOnes!='-')||item.rankOne">2025年</span>
								
								<span v-if="item.branchOnes&&item.branchOnes!='-'||item.rankOne">最低分/位次 {{item.branchOnes?item.branchOnes:'-'}}/{{item.rankOne?item.rankOne:'-'}}</span>
								
									<span v-if="item.planOne">录取{{item.planOne?item.planOne:'-'}}人</span>
							</div>
							
							<div class="maindewli">
								<span v-if="item.planTwo||(item.branchTwos&&item.branchTwos!='-')||item.rankTwo">2024年</span>
								
								<span v-if="item.branchTwos&&item.branchTwos!='-'||item.rankTwo">最低分/位次 {{item.branchTwos?item.branchTwos:'-'}}/{{item.rankTwo?item.rankTwo:'-'}}</span>
									<span v-if="item.planTwo">录取{{item.planTwo?item.planTwo:'-'}}人</span>
							</div>
							
							<div class="maindewli">
								<span v-if="item.planThree||(item.branchThrees&&item.branchThrees!='-')||item.rankThree">2023年</span>
								
								<span v-if="item.branchThrees&&item.branchThrees!='-'||item.rankThree">最低分/位次 {{item.branchThrees?item.branchThrees:'-'}}/{{item.rankThree?item.rankThree:'-'}}</span>
									<span v-if="item.planThree">录取{{item.planThree?item.planThree:'-'}}人</span>
							</div>
							
						</div>
					</div>
					<div class="schli-b">
						<el-button v-if="college_arr.includes(item.id)" type="danger" size="medium"  @click="addMajor(item.id);">
							{{!college_arr.includes(item.id)?'填报':'志愿'+(college_arr.indexOf(item.id)+1)}}
						</el-button>
						
						<el-button v-else type="info" size="medium" plain  @click="addMajor(item.id);">
							{{!college_arr.includes(item.id)?'填报':'志愿'+(college_arr.indexOf(item.id)+1)}}
						</el-button>
					</div>
				</div>
			</div>
			<el-empty v-if="user.userVip==1&&schList.length==0" :image-size="200"></el-empty>
			<div style="position: relative; min-height: 20vh; padding: 0px 0 0 0px; transform: translate(23%, 10%);" v-if="user.userVip==0">
				<nVip  v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip>
			</div>
			<div style="min-height: 70vh;" v-if="!token&&!user.score"><el-empty description="请先登录完善信息"></el-empty></div>
		</div>
	</div>
	<div ref="loadMoreTrigger" style="height: 20px;"></div>
	
	
	
	<!-- 悬浮框 -->
	<div id="tzy-selected-pop" :class="rightShow?'slide-out':''" cart-list="">
		<div class="shoppingCarLeft pull-left">
			<!-- <div class="foldBtn" @click="pullleftClick">
				<p class="f16">{{rightShow?'收起':'展开'}}志愿表</p> <span class="f18">{{college_arr&&college_arr.length?college_arr.length:0}}</span>
			</div> -->
			<div class="foldBtn" @click="goMyVol">
				<p class="f16">已选志愿</p> <span class="f18">{{college_arr&&college_arr.length?college_arr.length:0}}</span>
			</div>
			<button class="yzy-button save " style="color: #909399;" @click="allKong">清空</button>
			<button class="yzy-button save" @click="submitData" style="border-top: 0px;">保存</button>
			<button class="yzy-button save safe" style="border-top: 0px;" @click="topClick">顶部</button>
		</div>
		<div class="shoppingCarRight pull-right" style="height: 799px;">
			<div  class="cartList" style="height: 669px;">
				<div  class="cartListItem" v-for="(item,index) in college_arrShow">
					<div  class="cartCollege">
						<div  class="college-title dataType pull-left chong">
							<span class="college-num">{{index+1}}</span>
						</div> 
						<span class="cartCollegeName">{{item.schoolName}}</span> 
							<!-- <img src="../../assets/img/del.png" alt="" /> -->
					</div>
					<div  class="professionItem">
							<div class="ml30" style="display: flex;">
								<span  v-if="item.citySchoolName">{{item.citySchoolName}} | </span>
								<span style="margin-left: 6px;"  v-if="item.natureName">{{item.natureName}}</span>
							</div>
							
						<p  class="professionName ml30" style="font-weight: bold;font-size: 16px;"><span >{{item.majorName}}</span></p>
					</div>
				</div>
			</div>
			<button class="yzy-button creatsuccess">
				<p>保存志愿表</p> <span>( 已填{{college_arr&&college_arr.length?college_arr.length:0}}个志愿 )</span>
			</button>
		</div>
	</div>
	
	
	
	<!-- 基本信息 -->
	<el-dialog  title="AI一键填报" :visible.sync="aiOpen"  width="60vw" append-to-body class="view-dialog">
	  <!-- <div class="maintop" v-if="form.batNameRemark">
	    <div class="maintopcen">
	     <i class="el-icon-warning maintopcenleft"></i>
	      <div class="maintopcenrigth">
	          <h3>{{form.batNameRemark}}</h3>
	      </div>
	    </div>
	  </div> -->
	  <el-form ref="form" :model="form" :rules="rules" label-width="80px" class="elform">
	    <el-row :gutter="24">
	     <el-col :span="12">
	       <el-form-item label="意向城市:" >
	          <el-cascader @change='changVipCity' v-model='form.citySchoolIds'
	          	:options="getcityArr" :props="defaultPropscity" collapse-tags
	          	popper-class="popperclass" clearable></el-cascader>
	       </el-form-item>
	      </el-col>
		  <el-col :span="12">
		    <el-form-item label="意向专业:">
		       <el-cascader @change='changVipMajor' v-model='form.majorCodeAll'
		       	:options="getMajorArr" :props="defaultPropsmajor" collapse-tags
		       	popper-class="popperclass" clearable></el-cascader>
		    </el-form-item>
		   </el-col>
	     
	    </el-row>
	    <el-row :gutter="28">
	    	<el-col :span="28">
	    		<el-form-item label="院校类型(多选):" label-width="120px">
	    			<div class="kuai">
	    				<!-- <span v-for="item in filtrate.A"   :class="form.schoolType==item?'onsele':''" @click="clickVipB(item)">{{ item }}</span> -->
	    				<span v-for="item in filtrate.A"   :class="{onsele:form.schoolType.includes(item)}" @click="clickVipB(item)">{{ item }}</span>
						
	    			</div>
	    		</el-form-item>
	    	</el-col>
	    </el-row>
	    			
	    <el-row :gutter="28">
	    	<el-col :span="28" class="dataclass">
	    		<el-form-item label="办学性质(多选):" label-width="120px">
	    			<div class="kuai">
	    				<!-- <span v-for="item in filtrate.B"   :class="form.natureName==item?'onsele':''" @click="clickVipC(item)">{{ item }}</span> -->
						<span v-for="item in filtrate.B"   :class="{onsele:form.natureName.includes(item)}" @click="clickVipC(item)">{{ item }}</span>
	    			</div>
	    		</el-form-item>
	    	</el-col>
	    </el-row>
	    			
	    <el-row :gutter="28">
	    	<el-col :span="28">
	    		<el-form-item label="院校层次(多选):" label-width="120px">
	    			<div class="kuai">
	    				<!-- <span v-for="item in filtrate.C"   :class="form.attribute==item?'onsele':''" @click="clickVipD(item)">{{ item }}</span> -->
						
						<span v-for="item in filtrate.C"   :class="{onsele:form.attribute.includes(item)}" @click="clickVipD(item)">{{ item }}</span>
	    			</div>
	    		</el-form-item>
	    	</el-col>
	    </el-row>
		
		
		<el-row :gutter="28">
			<el-col :span="28">
				<el-form-item label="不选条件(多选):" label-width="120px">
					<div class="kuai">
						<span v-for="item in filtrate.K" :class="{onsele:form.notTtile.includes(item.titleName)}"  @click="clickVipE(item)">{{ item.titleName }}</span>
					</div>
				</el-form-item>
			</el-col>
		</el-row>
	   
	    <!-- <el-row :gutter="28">
	      <el-col :span="14">
	       <el-form-item label="备注" >
	         <el-input v-model="form.remark" placeholder="备注" />
	       </el-form-item>
	      </el-col>
	    </el-row> -->
	  </el-form>
	  <div slot="footer" class="dialog-footer" >
	    <el-button @click="cancel">取 消</el-button>
	    <el-button type="danger" @click="submitForm">确 定</el-button>
	  </div>
	</el-dialog>
	
	
	
	
	<div class="contentlog" v-show="logingColl">
		<div class="pro">
			<!-- <img class="loggig" src="../static/img/dili2.png" > -->
			<div class="tit">
				智能生成中
			</div>
			
			<img class="loggig" :src="UPLODE_URL+'17345994374991334.jpg'" alt="" />
			<!-- <div class="li">
				<progress class="progress" border-radius='10' activeColor="#fff"
					backgroundColor="rgb(0.901,0.901,0.901,0.1)" :percent="percent1" stroke-width='12'
					font-size="28" />
				<progress class="progress progresssss" border-radius='10' activeColor="#FF6505"
					backgroundColor="#FF6505" :percent="percent1" stroke-width='0' show-info font-size="28" />
			</div> -->
	
			<div class="pross">
				<div  v-if="percent1>7" class="scale-upA" style="font-size: 28rpx;opacity: 0.5;">成绩信息分析</div>
				<div  v-if="percent1>14" class="scale-upA" style="font-size: 30rpx;opacity: 0.6;">大学意向分析</div>
				<div  v-if="percent1>21" class="scale-upA" style="font-size: 32rpx;opacity: 0.7;">专业意向分析</div>
				<div  v-if="percent1>28" class="scale-upA" style="font-size: 34rpx;opacity: 0.8;">区域意向分析</div>
				<div  v-if="percent1>35" class="scale-upA" style="font-size: 36rpx;opacity: 0.9;">大数据匹配中</div>
				<div  v-if="percent1>42" class="scale-upA" style="font-size: 38rpx;opacity: 1;">防撞车验证中</div>
				<div  v-if="percent1>49" class="scale-upA" style="font-size: 40rpx;opacity: 1;">正在生成志愿表</div>
				<div  v-if="percent1>56" class="scale-up">......</div>
			</div>
			
			
			<!-- <div class="container">
			    <div
			      v-for="(threshold, index) in thresholds"
			      :key="index"
			      v-if="percent1 > threshold"
			      class="animated-text"
			      :style="{ fontSize: fontSizeMap[index] + 'rpx' }"
			    >
			      {{ getTextByThreshold(threshold) }}
			    </div>
			  </div> -->
		</div>
	</div>
	
	
    
  </div>
</template>

<script>
import { xuemengintro } from "@/api/intoxuemeng";
	import  {UPLODE_URL} from '@/utils/request'
	import { EventBus } from '@/utils/event-bus.js';
	import nVip from '@/components/n-vip.vue';
export default {
	components: {
		nVip
	},
  data() {
	  
    return {
		getschoolName:'',//搜索用到
		
		isLoggedIn: localStorage.getItem('loginStatus') === 'loggedIn',
		UPLODE_URL,
		logingColl: false,
		percent1: 0,
		
		
		
		token: localStorage.getItem('token')||'',
		user:JSON.parse(localStorage.getItem('user'))||'',
		
		aiOpen:false,
		form: {
		  // cityId:'',//省份id
		  // cityYear:'',//省份里面带的年 查询位次会用到
		  // batchId:'',//int(20) NULL	批次id
		  // batNameSSS:'',//判断是普通类还是艺术类
		  // batNameRemark:'',//选择完了批次 上面展示提示的提示文字
		  // statusType:'',	//int(20) NULL	1(6选3), 2(3+1+2), 3(7选3), 4(文理科)
		  // name:'',	//varchar(50) NULL	学生姓名
		  // mobile:'',	//varchar(11) NULL	手机号
		  // sex:'',	//int(1) NULL	1男2女
		  // culture:'',	//int(10) NULL	文化分
		  // art:'',	//int(10) NULL	专业分
		  // score:'',	//int(10) NULL	综合成绩
		  // scorePtn:'',	//int(10) NULL	位次
		  // subjectOne:[],//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
		  // subjectTwo:[],	//varchar(20) NULL	1物理，2化学，3生物，4历史，5政治，6地理，7文科，8理科
		  // userVip:'',	//int(1) NULL	vip，0否，1是
		  // scoreNum:'',	//int(5) NULL	分数可修改次数
		  // cityNum:'',	//int(5) NULL	省份可修改次数
		  // kemuNum:'',	//int(5) NULL	科目可修改次数
		  // remark:'',	//varchar(200) NULL	备注
		  
		  
		  schoolName: '',//学校名
		  schoolLevel:'',//本科和专科
		  citySchoolIds: [],//省份id 下拉选择传
		  citySchoolIdsNew:[],
		  majorCodeAll: [],// //专业id 下拉选择传
		  majorCodeAllsNew:[],
		  // majorNames: '', //专业名
		  schoolType: [], //院校类型
		  natureName: [], //办学性质
		  attribute: [], //院校层次
		  notTtile: [] ,//标签
		  schoolCityOne:[],
		},
		rules:{},
		
		
		
      filtrate: {
      	// A: ['综合', '理工', '财经', '艺术', '农业', '林业', '医药', '师范', '体育', '语言', '政法', '民族', '军事'],//院校类型
      	// B: ['公办', '民办', '独立学院', '中外合作办学', '内地与港澳台地区合作办学', '境外高校独立办学'],//办学性质
      	// C: ['985', '211', '研究生院', '双一流', '保研', '双高高职', '示范高职', '骨干高职'],//院校层次
		
		A: ['全部','综合','理工', '财经', '艺术', '农业', '林业', '医药', '师范', '体育', '语言', '政法', '民族', '军事'],//院校类型
		B: ['全部','公办', '民办', '独立学院', '中外合作办学', '内地与港澳台地区合作办学', '境外高校独立办学'],//办学性质
		C: ['全部','985', '211', '双一流', '保研', '双高高职'],//院校层次
		
		
		
		
		
		
		
      	D: [],//标签
      	E: [{ id: 1, name: '冲', num: 0 }, { id: 2, name: '稳', num: 0 }, { id: 3, name: '保', num: 0 }],
		F:[],
		G: ['是'],
		H: [{name:'101计划',id:'是',quer:'oneJihuas'},{name:'卓越工程师',id:'是',quer:'zuoyueJihuas'},{name:'国优计划',id:'是',quer:'youJihuas'}],
		// {name:'武书连',id:'是',quer:'wushulian'},
		J: [{name:'软科综合',id:'是',quer:'ruanke'},{name:'校友会综合',id:'是',quer:'xiaoyouhui'},{name:'QS',id:'是',quer:'QS'},{name:'US',id:'是',quer:'US'}],
		K:[]
      },
	  schList:[],
	  pageTotal:0,
	  busy: true,
	
	  // 查询参数
	  queryParams: {
	  	pageNum: 1,
	  	pageSize: 10,
		status:1,//第一志愿表还是第二志愿表
		userId: '',
		type:2,
		
		
	  	schoolName: '',//学校名
	  	schoolLevel:'',//本科和专科
	  	citySchoolIds: [],//省份id 下拉选择传
	  	majorCodeAlls: [],// //专业id 下拉选择传
	  	// majorNames: '', //专业名
	  	schoolType: [], //院校类型
	  	natureName: [], //办学性质
	  	attribute: [], //院校层次
	  	notTtile: [] ,//标签
	  	schoolCityOne:[],
		
	  },
	  
	  
	  isSticky: false,
	  stickyOffset: 0,
	  
	  jihuaIndex:2,
	  
	  
	  news_list:[],
	  news_total_page:0,//
	  college_arr:[],//选中的志愿id
	  college_arrShow:[],//选中的列表
	  
	  rightShow: false, //右侧弹框展示与隐藏
	  cardType: localStorage.getItem('cardType')||'',//1主卡2子卡
	  user:JSON.parse(localStorage.getItem('user'))||'',
	  
	  /**********筛选******/
	  getcityArr: [],//省份树
	  getMajorArr: [],//专业树
	  defaultPropscity: { //头部第二排 组件使用
	  	children: 'children',
	  	value: 'id',
	  	label: 'name',
	  	multiple: true
	  },
	  defaultPropsmajor: { //头部第二排 专业组件使用
	  	children: 'children',
	  	value: 'id',
	  	label: 'majorName',
	  	multiple: true
	  },
	  /**********筛选******/
    };
  },
  directives: {
      intersect: {
        bind(el, binding) {
          const observer = new IntersectionObserver((entries, observer) => {
			  console.log('entries',entries)
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const img = entry.target;
				console.log('2222sdfsfs',img)
                // 在这里可以做图片的懒加载处理，比如更改src属性
                // img.src = img.dataset.src;
                // 或者触发其他的方法
                // binding.value(entry, observer);
                // observer.unobserve(img); // 停止观察
				// this.createObserver();
              }
            });
          });
   
          observer.observe(el);
        }
      }
    },
  created() {
	  // if(!this.token) {
	  // 	EventBus.$emit('noopsycheOpen');
	  // 	return
	  // }else if(!this.user.score){
	  // 	EventBus.$emit('showModal');
	  // 	return
	  // }
	  
	 //  EventBus.$on('tui', () => {
	 //      this.token = localStorage.getItem('token')||''
	 //      this.user=JSON.parse(localStorage.getItem('user'))||''
	 //  	console.log('asdasdasdasdas111',this.token)
	 //  	console.log('asdasdasdasdas222',this.user)
		// this.city();
		// this.getList()
		// this.getAppJiNum()
		// this.myVolList()
	 //  });
    this.city();
	this.getList()
	this.getAppJiNum()
	this.myVolList()
	// 监听退出登录事件
	
	// this.stickyOffset = document.querySelector('.sticky').offsetTop;
  },
  mounted() {
	  // 登录完 确定完 去请求录取接口
	  EventBus.$on("callLoginDialog", () => {
	  	this.token=localStorage.getItem('token')||''
	  	this.user=JSON.parse(localStorage.getItem('user'))||''
	  	this.city();
		this.noSele()
	  	this.getList()
	  	this.getAppJiNum()
	  	this.myVolList()
	  });
	
	  this.token=localStorage.getItem('token')||''
	  
	  this.user=JSON.parse(localStorage.getItem('user'))||''
	  if(this.user.cityId){
	  		 this.noSele() 
	  }
  	  this.createObserver();
	  
	  window.addEventListener('storage', this.handleStorageEvent);
	  
	  window.addEventListener('scroll', this.handleScroll);
	  
  },
  
  beforeDestroy() {
	  window.removeEventListener('storage', this.handleStorageEvent);
	EventBus.$off('tui');
	// 移除 storage 事件监听器
	// window.removeEventListener('storage', this.handleStorageEvent);
	window.removeEventListener('scroll', this.handleScroll);  
    },
  methods: {
	  // 搜索框监听事件
	  inputChang(e){
	  		  console.log('e',e)
	  },
	  //
	  gogo(name){
	  	if(this.user.userVip==0){
	  		this.vipShow = true
	  		return
	  	}
	  	this.getschoolName = name
	  		
	  		this.queryParams.pageNum=1
	  		this.pageTotal = 0
	  		
	  	//数据列表
	  	this.schList=[]
	  	this.getList()
		this.getAppJiNum()
	  },
	  
	  
	  
	  // 不选
	  noSele(){
		  let qu={
			  cityId : this.user.cityId
		  }
		  this.api.baokaoTitleApi(qu).then(res => {
			  this.filtrate.K = res.data
		  })
	  },
	  //不选
	  xzCheckboxNotTtile(item){
	  	if (this.queryParams.notTtile.includes(item.titleName)) {
	  		this.queryParams.notTtile = this.queryParams.notTtile.filter(function(ele) {
	  			return ele != item.titleName;
	  		});
	  	} else {
	  		this.queryParams.notTtile.push(item.titleName);
	  	}
	  	// this.queryParams.notTtileName = this.queryParams.notTtile.toString()
		// this.schList = []
		this.queryParams.pageNum = 1;
		this.getList()
		this.getAppJiNum()
	  },
	  
	  
	  
	 handleStorageEvent(event) {
		 console.log('event',event.key)
	       if (event.key == 'token') {
	         // 更新登录状态
			this.token=localStorage.getItem('token')||''
			this.user=JSON.parse(localStorage.getItem('user'))||''
			this.$router.push({path:'/'})
			window.location.reload()
	         // this.checkLoginStatus();
	       }
		   if(event.key=='myarrLengrh'){
			   // let Arr = localStorage.getItem('myarrLengrh')
			   // this.college_arr == Arr.split(",")
			   console.log('myarrLengrhmyarrLengrhmyarrLengrhmyarrLengrhmyarrLengrhmyarrLengrh')
			   window.location.reload()
		   }
	     },

	  /*********************************一键填报**********************************/
	  // 专业
	  changVipMajor() {
	  	let arr = this.flatten(this.form.majorCodeAll); // arr2 [0, 1, 2, 3, 4, 5]
	  	this.form.majorCodeAllsNew = ([...new Set(arr)]);
	  	
	  },
	  // 省份
	  changVipCity() {
	  	let arr = this.flatten(this.form.citySchoolIds); // arr2 [0, 1, 2, 3, 4, 5]
	  	this.form.citySchoolIdsNew = ([...new Set(arr)]);
	  },
	  // 院校类型 点击
	  clickVipB(item){
		   // if(this.form.schoolType == item){
			  //  this.form.schoolType = ''
		   // }else{
			  //  this.form.schoolType = item
		   // }
		   
		   
		   if(item=='全部'){
		   			   console.log('this.form.schoolType',this.form.schoolType)
		   	if(this.form.schoolType.includes('全部')){
		   		this.form.schoolType = []
		   	}else{
		   		this.form.schoolType = []
		   		this.form.schoolType.push(item);
		   	}
		   	
		   }else{
		   	this.form.schoolType = this.form.schoolType.filter(item => item !== '全部');
		   	if (this.form.schoolType.includes(item)) {
		   		this.form.schoolType = this.form.schoolType.filter(function(ele) {
		   			return ele != item;
		   		});
		   	} else {
		   		if(item!='全部'){
		   			this.form.schoolType.push(item);
		   		}
		   	}
		   }
		   
	  },
	  // 院校性质 点击
	  clickVipC(item){
		   // if(this.form.natureName == item){
			  //  this.form.natureName = ''
		   // }else{
			  //  this.form.natureName = item
		   // }
		   
		   
		   
		   if(item=='全部'){
		   			   console.log('this.form.natureName',this.form.natureName)
		   	if(this.form.natureName.includes('全部')){
		   		this.form.natureName = []
		   	}else{
		   		this.form.natureName = []
		   		this.form.natureName.push(item);
		   	}
		   	
		   }else{
		   	this.form.natureName = this.form.natureName.filter(item => item !== '全部');
		   	if (this.form.natureName.includes(item)) {
		   		this.form.natureName = this.form.natureName.filter(function(ele) {
		   			return ele != item;
		   		});
		   	} else {
		   		if(item!='全部'){
		   			this.form.natureName.push(item);
		   		}
		   	}
		   }
	  		
	  },
	  
	  // 院校层次 点击
	  clickVipD(item){
		   // if(this.form.attribute == item){
			  //  this.form.attribute = ''
		   // }else{
			  //  this.form.attribute = item
		   // }
		   
		   
		   if(item=='全部'){
		   			   console.log('this.form.attribute',this.form.attribute)
		   	if(this.form.attribute.includes('全部')){
		   		this.form.attribute = []
		   	}else{
		   		this.form.attribute = []
		   		this.form.attribute.push(item);
		   	}
		   	
		   }else{
		   	this.form.attribute = this.form.attribute.filter(item => item !== '全部');
		   	if (this.form.attribute.includes(item)) {
		   		this.form.attribute = this.form.attribute.filter(function(ele) {
		   			return ele != item;
		   		});
		   	} else {
		   		if(item!='全部'){
		   			this.form.attribute.push(item);
		   		}
		   	}
		   }
	  },
	  //不选
	  clickVipE(item){
	  	if (this.form.notTtile.includes(item.titleName)) {
	  		this.form.notTtile = this.form.notTtile.filter(function(ele) {
	  			return ele != item.titleName;
	  		});
	  	} else {
	  		this.form.notTtile.push(item.titleName);
	  	}
	  },
	  
	  
	  // 取消
	  cancel(){
		this.aiOpen = false
	  },
	  //btn
	  yijianClick(){
		  if(!this.token) {
		  	EventBus.$emit('noopsycheOpen');
		  }else if(!this.user.score){
		  	EventBus.$emit('showModal');
		  	return
		  }else if(this.user.userVip==0){
		  	EventBus.$emit('vipOpen');
		  	return
		  }else{
		  	this.aiOpen = true
		  }
	  },
	  // 确定一键填报
	  submitForm(){
		  let that = this
		  that.logingColl = true;
		  var clearInt = setInterval(() => {
		  	that.percent1++;
		  	that.percent1++;
		  	if (that.percent1 >= 100) {
		  		clearInterval(clearInt)
		  	}
		  }, 80)
		  let qu = {
			  status:1,
			  citySchoolIds:that.form.citySchoolIdsNew?that.form.citySchoolIdsNew.toString():'',
			  majorCodeAll:that.form.majorCodeAllsNew?that.form.majorCodeAllsNew.toString():'',
			  // natureName:that.form.natureName?that.form.natureName.toString():'',
			  // attribute:that.form.attribute?that.form.attribute.toString():'',
			  // schoolType:that.form.schoolType||'',
			  notTtile:that.form.notTtile?that.form.notTtile.toString():'',
			  schoolType:this.form.schoolType.includes('全部')?'':this.form.schoolType.toString(),
			  attribute:this.form.attribute.includes('全部')?'':this.form.attribute.toString(),
			  natureName:this.form.natureName.includes('全部')?'':this.form.natureName.toString(),
			  cardType:that.cardType 
		  }
		  console.log('qu',qu)
		  
		  that.api.appJihuaBigDataApi(qu).then(res => {
			  if(res.code==200){
				  that.$message.success('操作成功');
				  that.aiOpen = false
				  that.myVolList()
				  setTimeout(function(){
				  	clearInterval(clearInt);
				  	that.percent1 = 0
				  	that.goMyVol()
				  	that.logingColl = false;
				  },3000)
			  }else{
				  that.$message.error(res.msg);
				  that.logingColl = false;
				  clearInterval(clearInt);
				  that.percent1 = 0;
			  }
		  })
		  
	  },
	  /*********************************一键填报**********************************/
	  
	  
	  
	  
	  
	  //获取我的志愿表
	  myVolList(){
		  let qu = {
		  	status:this.queryParams.status,
		  	sort:2,
		  }
		  this.api.getAppMyJihuaApi(qu).then(res => {
			  if(res.code==200){
				  if(res.data){
					  this.college_arr=[]
					  this.college_arrShow=[]
					  
					  this.college_arrShow = res.data
					  res.data.map((item, index) => {
					  	// 计算scroll-view的宽度，这里
					  	this.college_arr.push(item.id) 
					  })
				  }else{
					  this.college_arr=[]
					  this.college_arrShow = []
				  }
			  }else{
				  this.$message.error(res.msg);
			  }
		  })
	  },
	  //选择志愿
	  addMajor(id){
	  	//是否要更新
	  	this.update = true;
	  	// return
	  	let length = 96;
	  	if (this.college_arr.length >= length) {
	  		if (!this.college_arr.includes(id)) {
	  			uni.showToast({
	  				title: '省招办规定最多填报' + length + '组志愿',
	  				icon: 'none'
	  			})
	  			return
	  		}
	  		this.college_arr = this.college_arr.filter(function(ele) {
	  			return ele != id;
	  		});
	  	} else {
	  		if (!this.college_arr.includes(id)) {
	  			this.college_arr.push(id)
	  			return
	  		}
	  		this.college_arr = this.college_arr.filter(function(ele) {
	  			return ele != id;
	  		});
	  	}
	  	
	  	// console.log(this.major_arr,'专业数组');
	  },
	  
	  //提交保存
	  async submitData(i){
	  	if (!this.college_arr.length) {
			this.allKongS()
			// this.$message({
			//   message: '请预选志愿',
			//   type: 'warning',
			//   duration: '4000'
			// });
	  		return
	  	}
	  	//提前声明
	  	let college_arr = this.college_arr;
		localStorage.setItem('college_arr',college_arr)
	  	college_arr = college_arr.join(",");
	  	
	  	let quer = {}
	  	if(this.queryParams.status==1){
	  		 quer= {
	  			jihuaIds:college_arr,
	  			status:0,
	  			cardType:this.cardType
	  			// cardType:2
	  		}
	  	}
	  	if(this.queryParams.status==2){
	  		 quer= {
	  			jihuaIdsBack:college_arr,
	  			status:0,
	  			cardType:this.cardType,
	  			// cardType:2
	  		}
	  	}
	  	
	  	
		this.api.getAppMyAddJihuaApi(quer).then(res => {
		  if(res.code==200){
			  if(i==1){
			  }else{
				  this.$message.success('保存成功');
			  }
		  }else{
			  this.$message.error(res.msg);
		  }
		})
		
	  },
	  // 当取消填报 点击保存 走的清空接口
	  allKongS(){
		let quer= {
			 status:this.queryParams.status,
			 cardType:this.cardType,
		}
		this.api.getAppMyAddJihuaApi(quer).then(res => {
		  if(res.code==200){
			    this.$message.success('操作成功');
				this.college_arr = []
		  }else{
			  this.$message.error(res.msg);
		  }
		})
	  },
	  
	  
	  allKong(){
		this.$confirm('清空后将无法回复，确定此操作？','提示').then(function() {
		}).then(() => {
		 let quer= {
			 status:this.queryParams.status,
			 cardType:this.cardType,
		 }
		 this.api.getAppMyAddJihuaApi(quer).then(res => {
		   if(res.code==200){
		 	 this.$message.success('操作成功');
			  this.college_arr = []
		   }else{
		 	  this.$message.error(res.msg);
		   }
		 })
		}).catch(() => {});  
	  },
	  
	  
	  //点击右侧悬浮框
	  pullleftClick() {
	  	this.rightShow = !this.rightShow
	  },
	  // 页面返回到顶部
	  topClick() {
	  	const scrollToTop = setInterval(() => {
	  		const currentPosition = document.documentElement.scrollTop || document.body.scrollTop;
	  		if (currentPosition > 0) {
	  			window.requestAnimationFrame(() => {
	  				window.scrollTo(0, currentPosition - currentPosition / 8);
	  			});
	  		} else {
	  			clearInterval(scrollToTop);
	  		}
	  	}, 16); // 16ms 是一个合理的帧率间隔，可以保持动画的流畅
	  },
	  
	 
	  handleScroll() {
	        this.isSticky = window.scrollY >= this.stickyOffset;
	    },
	  // 跳转学校详情
	  goInfo(item){
		  // localStorage.setItem('xiaoid',item.schoolId)
		  // this.$router.push({path:'/Ainformation/schoolInfo'})
		  // return
		  
		  
		  
		const route =this.$router.resolve({name:'schoolInfo',})
		localStorage.setItem('xiaoid',item.schoolId)
		localStorage.setItem('schoolName',this.queryParams.schoolName)
		
		
		// 打开新窗口并导航至生成的URL
		window.open(route.href, '_blank');
	  },
	  // 跳转学校详情
	  goMyVol(){
		  // this.$router.push({path:'/AAIvol/myVol'})
		  // return
	  		const route =this.$router.resolve({name:'myVol',})
	  		// localStorage.setItem('xiaoid',item.schoolId)
	  		// 打开新窗口并导航至生成的URL
	  		window.open(route.href, '_blank');
	  },
	  handleIntersect(entry, observer){
		  if (this.queryParams.pageNum >= this.pageTotal ) {
		  	// this.$message({
		  	//   message: '没有更多了',
		  	//   type: 'warning',
		  	//   duration: '4000'
		  	// });
		  	return
		  }
		  // this.busy = true
		  if(this.user&&this.user.userVip==0){
			  return
		  }
		  this.queryParams.pageNum++;
		  this.getList('more')
	  },
	  createObserver() {
		const options = {
		  root: null, // viewport
		  rootMargin: '250px',
		  threshold: 1.0
		};
		const observer = new IntersectionObserver(this.handleIntersect, options);
		observer.observe(this.$refs.loadMoreTrigger);
	  },
	  creat(){
		  
	  },
	  // 获取筛选省份
	   city(){
		   //省份
		   this.api.AppgetCityLibraryApi().then(res => {this.getcityArr = this.getTreeData(res.data)})
		   //专业
		   let qu={
			   batchId:this.user.batchId
		   }
		   this.api.AppgetMajorLibraryApi(qu).then(res => {this.getMajorArr = this.getTreeData(res.data)})
	   },
	   
	   // 递归判断列表，把最后的children设为undefined
	   getTreeData(data) {
	   	for (var i = 0; i < data.length; i++) {
	   		if (data[i].children.length < 1) {
	   			// children若为空数组，则将 children 设为undefined
	   			data[i].children = undefined;
	   		} else {
	   			// children若不为空数组，则继续 递归调用 本方法
	   			this.getTreeData(data[i].children);
	   		}
	   	}
	   	return data;
	   },
	   // 专业
	   changMajor() {
	   	let arr = this.flatten(this.queryParams.majorCodeAlls); // arr2 [0, 1, 2, 3, 4, 5]
	   	this.queryParams.majorCodeAllsNew = ([...new Set(arr)]);
		this.getList()
		this.getAppJiNum()
	   },
	   // 省份
	   changCity() {
	   	let arr = this.flatten(this.queryParams.citySchoolIds); // arr2 [0, 1, 2, 3, 4, 5]
	   	this.queryParams.citySchoolIdsNew = ([...new Set(arr)]);
	   	// localStorage.setItem("CITYSELE", this.queryParams.citySchoolIds);
	   	// this.Postpr()
		this.getList()
		this.getAppJiNum()
	   },
	   
	   // 数组去重
	   flatten(arr) {
	   	return [].concat(...arr.map(x => Array.isArray(x) ? this.flatten(x) : x))
	   },
	   // 院校所属 点击
	   clickA(item){
		   if(this.queryParams.schoolCityOne == item.name){
		   		this.queryParams.schoolCityOne = ''
		   }else{
		   		this.queryParams.schoolCityOne = item.name
		   }
		   this.queryParams.pageNum = 1;
		   this.getList()
		   this.getAppJiNum()
	   },
	   // 院校类型 点击
	   clickB(item){
		   console.log('item',item)
		   // if(this.queryParams.schoolType == item){
			  //  this.queryParams.schoolType = ''
		   // }else{
			  //  this.queryParams.schoolType = item
		   // }
		   
		   if(item=='全部'){
			   console.log('this.queryParams.schoolType',this.queryParams.schoolType)
		   	if(this.queryParams.schoolType.includes('全部')){
		   		this.queryParams.schoolType = []
		   	}else{
		   		this.queryParams.schoolType = []
		   		this.queryParams.schoolType.push(item);
		   	}
		   	
		   }else{
		   	this.queryParams.schoolType = this.queryParams.schoolType.filter(item => item !== '全部');
		   	if (this.queryParams.schoolType.includes(item)) {
		   		this.queryParams.schoolType = this.queryParams.schoolType.filter(function(ele) {
		   			return ele != item;
		   		});
		   	} else {
		   		if(item!='全部'){
		   			this.queryParams.schoolType.push(item);
		   		}
		   	}
		   }
		   
		   
		   
		   
		   
		   
		   
		   
		   
		   this.queryParams.pageNum = 1;
		   this.getList()
		   this.getAppJiNum()
	   },
	   // 院校性质 点击
	   clickC(item){
		   // if(this.queryParams.natureName == item){
			  //  this.queryParams.natureName = ''
		   // }else{
			  //  this.queryParams.natureName = item
		   // }
		   if(item=='全部'){
		   			   console.log('this.queryParams.natureName',this.queryParams.natureName)
		   	if(this.queryParams.natureName.includes('全部')){
		   		this.queryParams.natureName = []
		   	}else{
		   		this.queryParams.natureName = []
		   		this.queryParams.natureName.push(item);
		   	}
		   	
		   }else{
		   	this.queryParams.natureName = this.queryParams.natureName.filter(item => item !== '全部');
		   	if (this.queryParams.natureName.includes(item)) {
		   		this.queryParams.natureName = this.queryParams.natureName.filter(function(ele) {
		   			return ele != item;
		   		});
		   	} else {
		   		if(item!='全部'){
		   			this.queryParams.natureName.push(item);
		   		}
		   	}
		   }
		   
		   
		   
		   
		   
		   this.queryParams.pageNum = 1;
		   this.getList()
		   this.getAppJiNum()
	   },
	   
	   // 院校层次 点击
	   clickD(item){
	   		   // if(this.queryParams.attribute == item){
	   			  //  this.queryParams.attribute = ''
	   		   // }else{
	   			  //  this.queryParams.attribute = item
	   		   // }
			   
			   if(item=='全部'){
			   			   console.log('this.queryParams.attribute',this.queryParams.attribute)
			   	if(this.queryParams.attribute.includes('全部')){
			   		this.queryParams.attribute = []
			   	}else{
			   		this.queryParams.attribute = []
			   		this.queryParams.attribute.push(item);
			   	}
			   	
			   }else{
			   	this.queryParams.attribute = this.queryParams.attribute.filter(item => item !== '全部');
			   	if (this.queryParams.attribute.includes(item)) {
			   		this.queryParams.attribute = this.queryParams.attribute.filter(function(ele) {
			   			return ele != item;
			   		});
			   	} else {
			   		if(item!='全部'){
			   			this.queryParams.attribute.push(item);
			   		}
			   	}
			   }
			   
			   
			   
			  this.queryParams.pageNum = 1;
			  this.getList()
			  this.getAppJiNum()
	   },
	   // 院校排名 
	   clickE(item){
	   	if(item.name=='软科综合'){
	   		if(this.queryParams.ruanke == item.quer){
	   			this.queryParams.ruanke=''
	   			return
	   		}
	   		this.queryParams.ruanke = item.quer
	   		
	   		this.queryParams.xiaoyouhui=''
	   		this.queryParams.qs=''
	   		this.queryParams.us=''
	   		
	   	}
	   	if(item.name=='校友会综合'){
	   		if(this.queryParams.xiaoyouhui == item.quer){
	   			this.queryParams.xiaoyouhui=''
	   			return
	   		}
	   		this.queryParams.xiaoyouhui = item.quer
	   		
	   		
	   		this.queryParams.ruanke = ''
	   		// this.queryParams.xiaoyouhui=''
	   		this.queryParams.qs=''
	   		this.queryParams.us=''
	   	}
	   	if(item.name=='QS'){
	   		if(this.queryParams.qs == item.quer){
	   			this.queryParams.qs=''
	   			return
	   		}
	   		this.queryParams.qs = item.quer
	   		
	   		this.queryParams.ruanke = ''
	   		this.queryParams.xiaoyouhui=''
	   		// this.queryParams.qs=''
	   		this.queryParams.us=''
	   	}
	   	if(item.name=='US'){
	   		if(this.queryParams.us == item.quer){
	   			this.queryParams.us=''
	   			return
	   		}
	   		this.queryParams.us = item.quer
	   		
	   		this.queryParams.qs = ''
	   		this.queryParams.ruanke = ''
	   		this.queryParams.xiaoyouhui=''
	   	}
	   	
	   },
	   clickF(item){
		   if(item.name=='101计划'){
		   	if(this.queryParams.oneJihuas == item.quer){
		   		this.queryParams.oneJihuas=''
		   		return
		   	}
		   	this.queryParams.oneJihuas = item.quer
		   }
		   if(item.name=='卓越工程师'){
		   	if(this.queryParams.zuoyueJihuas == item.quer){
		   		this.queryParams.zuoyueJihuas=''
		   		return
		   	}
		   	this.queryParams.zuoyueJihuas = item.quer
		   }
		   if(item.name=='国优计划'){
		   	if(this.queryParams.youJihuas == item.quer){
		   		this.queryParams.youJihuas=''
		   		return
		   	}
		   	this.queryParams.youJihuas = item.quer
		   }
	   },
	   
	   schGet(){
		   this.queryParams.pageNum = 1;
		   this.getschoolName='schoolName'
		   this.getList()
		   this.getAppJiNum()
	   },
	   // handleScroll(e) {
		  //  console.log('11111',e)
	   //       const bottomOffset = 50; // 距离底部多少像素时触发加载
	   //       const scrollContainer = this.$refs.scrollContainer;
	   //       if (scrollContainer.scrollHeight - (scrollContainer.scrollTop + scrollContainer.clientHeight) < bottomOffset) {
	   //         this.getList();
	   //       }
	   //     },
	   
	   // 点击计划数量 请求接口
	   navNum(item){
		   let ss =  localStorage.getItem('college_arr')||'';
		   if(ss==this.college_arr){
			   console.log('等于')
		   }else{
			   if(this.college_arr.length){
				   this.submitData(1)
			   }
		   }
			this.queryParams.pageNum=1
		   this.jihuaIndex = item.id
		   this.queryParams.type = item.id
		   this.getList()
	   },
	   
	   // 数据列表请求
	   getList(type){
		   let qu = {
			   // schoolName:this.queryParams.schoolName,
			   schoolName:this.getschoolName=='schoolName'?this.queryParams.schoolName:'',
			   majorNames:this.getschoolName=='majorNames'?this.queryParams.schoolName:'',
			   
			   citySchoolIds: this.queryParams.citySchoolIdsNew ? this.queryParams.citySchoolIdsNew.toString() : '',//省份id 下拉选择传
			   majorCodeAlls: this.queryParams.majorCodeAllsNew ? this.queryParams.majorCodeAllsNew.toString() : '',// //专业id 下拉选择传
			   // pageNum:this.queryParams.pageNum,
			   // pageSize:10,
			   
			   // natureName:this.queryParams.natureName.toString()||'',
			   natureName:this.queryParams.natureName.includes('全部')?'':this.queryParams.natureName.toString(),
			   
			   
			   // attribute:this.queryParams.attribute.toString()||'',
			   attribute:this.queryParams.attribute.includes('全部')?'':this.queryParams.attribute.toString(),
			   
			   // schoolType:this.queryParams.schoolType||'',
			   schoolType:this.queryParams.schoolType.includes('全部')?'':this.queryParams.schoolType.toString(),
			   
			   
			 
			   notTtile:   this.queryParams.notTtile ?   this.queryParams.notTtile.toString() : '',
			   
			   // schoolCityOne:this.queryParams.schoolCityOne.toString()||'',
			   // oneJihuas:this.queryParams.oneJihuas?'是':'',
			   // zuoyueJihuas:this.queryParams.zuoyueJihuas?'是':'',
			   // youJihuas:this.queryParams.youJihuas?'是':'',
			   // ruanke:this.queryParams.ruanke?1:0,
			   // xiaoyouhui:this.queryParams.xiaoyouhui?1:0,
			   // qs:this.queryParams.qs?1:0,
			   // us:this.queryParams.us?1:0,
			   // schoolLevel:this.queryParams.schoolLevel,//本科或者专科
			   
			   status:this.queryParams.status,
			   type:this.queryParams.type,
			   pageNum: this.queryParams.pageNum,
			   pageSize: 10
		   }
		   
		   
		    this.api.getAppJihua(qu).then(res => {
				if(res.code==200){
					
					if (type == 'more') {
						if (!res.data) {
							this.$message({
								message: '没有更多了',
								type: 'warning',
								duration: '4000'
							});
							return
						}
						this.schList = [...this.schList, ...res.data.rows];
						
					}else{
						this.schList = []
						this.schList = res.data ? res.data.rows : [];
						// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
						this.pageTotal = res.data ? res.data.pageTotal : 0;
					}
					
					
					// if(res.data&&res.data.rows){
					// 	this.pageTotal = res.data.pageTotal
					// 	this.schList = res.data.rows;
						
					// 	// this.schList = [...this.schList, ...res.data.rows];
						
					// }else{
					// 	this.schList = []
					// }
				}else{
					 this.$message.error(res.msg);
					 this.schList = []
					 this.pageTotal = 0
				}
			})
	   },
	   getAppJiNum(){
		   let qu = {
		   			   // schoolName:this.queryParams.schoolName,
					   schoolName:this.getschoolName=='schoolName'?this.queryParams.schoolName:'',
					   majorNames:this.getschoolName=='majorNames'?this.queryParams.schoolName:'',
					   
					   attribute:this.queryParams.attribute.includes('全部')?'':this.queryParams.attribute.toString(),
					   
					   
		   			   citySchoolIds: this.queryParams.citySchoolIdsNew ? this.queryParams.citySchoolIdsNew.toString() : '',//省份id 下拉选择传
		   			   majorCodeAlls: this.queryParams.majorCodeAllsNew ? this.queryParams.majorCodeAllsNew.toString() : '',// //专业id 下拉选择传
		   			   // pageNum:this.queryParams.pageNum,
		   			   // pageSize:10,
		   			   // natureName:this.queryParams.natureName.toString()||'',
		   			   // attribute:this.queryParams.attribute.toString()||'',
		   			   // schoolType:this.queryParams.schoolType||'',
		   			   // schoolCityOne:this.queryParams.schoolCityOne.toString()||'',
		   			   // oneJihuas:this.queryParams.oneJihuas?'是':'',
		   			   // zuoyueJihuas:this.queryParams.zuoyueJihuas?'是':'',
		   			   // youJihuas:this.queryParams.youJihuas?'是':'',
		   			   // ruanke:this.queryParams.ruanke?1:0,
		   			   // xiaoyouhui:this.queryParams.xiaoyouhui?1:0,
		   			   // qs:this.queryParams.qs?1:0,
		   			   // us:this.queryParams.us?1:0,
		   			   // schoolLevel:this.queryParams.schoolLevel,//本科或者专科
		   			   // natureName:this.queryParams.natureName.toString()||'',
		   			   status:this.queryParams.status,
		   			   type:this.queryParams.type,
					   
					   notTtile:this.queryParams.notTtile ? this.queryParams.notTtile.toString() : '',
					   
					   
					   
					   schoolType:this.queryParams.schoolType.includes('全部')?'':this.queryParams.schoolType.toString(),
					   natureName:this.queryParams.natureName.includes('全部')?'':this.queryParams.natureName.toString(),
		   }
		   
		   this.api.getAppJihuaNum(qu).then(res => {
			   if(res.code==200){
				   this.filtrate.E[0].num = res.data.countOne;
				   this.filtrate.E[1].num = res.data.countTwo;
				   this.filtrate.E[2].num = res.data.countThree;
			   }else{
				   this.filtrate.E[0].num =0;
				   this.filtrate.E[1].num = 0;
				   this.filtrate.E[2].num = 0;
			   }
		   })
	   }
	   
	   
	   
  },
};
</script>

<style lang="scss" scoped>
.img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.box{
	/deep/.el-form-item__content{
		flex: 1;
	}
	.el-form-item--small.el-form-item {
		margin-bottom: 5px;
	}
	// height: 100vh;
	// min-height: 30vh;
	.boxA{
		background: #fff;
		border-radius: 10px;
		padding: 20px;
		margin-top: 10px;
		.box-tit{
			width: 100%;
			height: 40px;
			line-height: 40px;
			border-bottom: 1px solid #F44F4D;
			margin-bottom: 15px;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				background-color: #F44F4D;
				color: #fff;
				display: block;
				border-radius: 10px 10px 0 0;
				text-align: center;
				font-size: 15px;
			}
		}
		
		.search-t{
			width: 40%;
			margin-bottom: 10px;
			.input-with-select{
				border-radius: 4px;
				/deep/.el-input__inner{
					border-color: #F56C6C!important;
				}
				/deep/.el-button--danger{
					border: none!important;
				}
				/deep/.el-button{
					border: 1px solid #f44f4d!important;
					background: #f44f4d;
					color: #fff;
					border-radius: 0  4px 4px 0px;
				}
			}
		}
		
		.topsec{
			position: relative;
			.kuai{
				display: flex;
				flex-wrap: wrap;
				span{
					margin-right: 20px;
					cursor: pointer;
				}
				span.onsele{
					color: #F44F4D;
				}
			}
			.el-form-item {
				display: flex;
			}
		}
	}
	
	.schmain{
		margin-top: 12px;
		.box-tit{
			width: 100%;
			border-bottom: 1px solid #F44F4D;
			display: flex;
			background: #fff;
			padding-top: 10px;
			border-radius: 10px 10px 0 0;
			span{
				width: 140px;
				height: 40px;
				line-height: 40px;
				// background-color: #F44F4D;
				color: #333;
				display: block;
				border-radius: 10px 10px 0 0;
				text-align: center;
				font-size: 15px;
				cursor: pointer;
			}
			span.onsele{
				background-color: #F44F4D;
				color: #fff;
				
			}
		}
		
		.sch-ul{
			background: #fff;
			
			.sch-li{
				margin-bottom: 10px;
				display: flex;
				// align-items: center;
				padding: 20px;
				// border-radius: 10px;
				display: flex;
				border-bottom: 1px solid #EEEEEE;
				.schli-l{
					width: 60px;
					margin-right: 20px;
					// img{
					// 	width: 60px;
					// 	height: 60px;
					// 	border-radius: 50%;
					// }
					
					
					.exaboxconli-l{
						text-align: center;
						position: relative;
					
						.btitle{
							font-size: 12px;
							color: #666666;
							white-space:nowrap
						}
						.bnum{
							position: absolute;
							top: 4px;
							left: 18px;
							font-size: 12px;
							color: #fff;
						}
						img{
							width: 46px;
							height: 53px;
						}
					}
					
				}
				.schli-r{
					flex: 1;
					.schli-rt{
						font-size: 18px;
						margin-bottom: 10px;
						cursor: pointer;
						.schli-rt-a{
							
						}
						.schli-rt-b{
							font-weight: bold;
							line-height: 44px;
						}
					}
					.schli-rB{
						display: flex;
						span{
							margin-right: 10px;
							font-size: 14px;
							color: #646464;
						}
					}
					
					.schli-rc{
						display: flex;
						white-space:nowrap;
						.schli-rcA{
							display: flex;
							margin-right: 20px;
							span{
								color: #747474;
								font-size: 14px;
							}
							.span1{
								color: #000000;
								padding-left: 4px;
							}
						}
					}
					
					
					.maindew{
						margin-top: 10px;
						.maindewli{
							display: flex;
							span{
								margin-right: 20px;
								font-size: 13px;
							}
						}
					}
				}
				.schli-b{
					width: 100px;
					text-align: center;
					.el-button{
						width: 100px;
					}
				}
			}
		}
	}
}

.sticky {
  position: sticky;
  top: 0;
  background-color: white;
  z-index: 1000;
}






// 悬浮框
#tzy-selected-pop {
    right: 0;
    position: fixed;
    top: 65px;
    width: 418px;
    height: 270px;
    z-index: 3000;
    -webkit-transition: all 1s;
    transition: all 1s;
    -webkit-transform: translateX(366px);
    transform: translateX(366px);
	display: flex;
}

#tzy-selected-pop.slide-out {
    -webkit-transform: translateX(0);
    transform: translateX(0)
}

#tzy-selected-pop .shoppingCarLeft {
    width: 52px;
    height: 270px;
    cursor: pointer
}
.pull-left {
    float: left
}


#tzy-selected-pop .foldBtn {
    display: inline-block;
    border: 1px solid transparent;
    border-right: none;
    border-top-left-radius: 4px;
    color: #fff;
    background: #F16334;
}
.f16 {
    font-size: 16px
}
.f18 {
    font-size: 18px
}
.yzy-button {
    border: 1px solid #F16334;
	color: #F16334;
}
.yzy-button.save {
    font-size: 14px;
    width: 52px;
    height: 60px;
	background-color: #fff;
}

.yzy-button.save:hover{
	color: red;
}

 .yzy-button.safe {
    border-bottom-left-radius: 4px;
}

#tzy-selected-pop .foldBtn>p {
    line-height: 22px;
    padding: 16px 16px;
    display: inline-block
}
#tzy-selected-pop .foldBtn>span {
    line-height: 25px;
    text-align: center;
    margin-bottom: 16px;
    display: inline-block;
    width: 100%
}
#tzy-selected-pop .shoppingCarRight {
    width: 366px;
    background: #fff;
    border: 1px solid #e6e6e6;
    border-radius: 0 0 0 4px;
    height: 100%;
    overflow: hidden
}

#tzy-selected-pop .searchInput {
    margin: 15px 20px 0;
    height: 40px;
    font-size: 12px;
    line-height: 18px;
    width: 326px
}

.ml30 {
    margin-left: 30px!important;
}
#tzy-selected-pop .chong.dataType{
    color: #fff;
    border-color: #e9302d;
    background-color: #e9302d;
}
.college-num {
    display: block;
    min-width: auto;
    min-height: 16px;
}
#tzy-selected-pop .professionItem {
    font-size: 14px;
    line-height: 22px;
    margin-top: 12px;
}
.professionName {
    width: 294px;
    display: inline-block;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
}
#tzy-selected-pop .cartCollegeName {
    display: inline-block;
    margin-left: 12px;
    width: 280px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    color: #212121;
}
#tzy-selected-pop .dataType{
    height: 18px;
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    padding: 0 4px;
}
.cartList{
    width: 100%;
    padding: 0 20px;
    overflow-y: auto;
	.cartListItem  {
	    padding: 20px 0;
	    border-bottom: 1px solid #e6e6e6;
		.cartCollege {
		    width: 100%;
		    line-height: 18px;
		    overflow: hidden;
		    height: 18px;
		    display: -webkit-box;
		    display: -ms-flexbox;
		    display: flex;
		}
	}
}



.toc0 .yzy-button.creat, .toc0 .yzy-button.creatsuccess {
    background-color: #F16334;
}.yzy-button.creatsuccess {
    margin-left: 20px;
    width: 336px;
    height: 44px;
    border: none;
    line-height: 44px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border-radius: 4px;
	background-color: #F16334;
	color: #fff;
	font-size: 16px;
}
.el-cascader{
	width: 80%;
}
.elbu-vip{
    color: #613700;
}
.view-dialog /deep/.el-dialog {
  border-radius: 10px!important;
}

.elform{
	// background: linear-gradient(90deg, rgba(250, 175, 62, 1) 0%, rgba(247, 49, 49, 1) 100%);
	.kuai{
		display: flex;
		flex-wrap: wrap;
		span{
			margin-right: 20px;
			cursor: pointer;
		}
		span.onsele{
			color: #F44F4D;
		}
	}
}




	.contentlog {
		width: 100%;
		height: 100vh;
		overflow: hidden;
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		z-index: 99999;
		background-color: #fff;
		.pross{
			text-align: center;
			margin-top: 10px;
			.scale-upA{
				font-size: 16px;
				margin-bottom: 4px;
			}
		}
		.li {
			.probot {
				width: 100%;
				height: 15px;
				background-color: #ccc;
				border-radius:10px;
			}
	
			.protop {
				height: 15px;
				background-color: #0071FD;
				position: relative;
				top: -15px;
				border-radius:10px;
			}
	
	
	
	
	
			// display: flex;
			margin-top: 70px;
	
			span {
				width: 100px;
				color: #fff;
			}
	
			.progress {
				flex: 1;
				color: #fff;
			}
	
			.progresssss {
				width: 62% !important;
				margin-top: 10px;
			}
	
	
		}
	
		.pro {
			width: 90%;
			margin: 0px auto;
			padding-top: 5vh;
		}
	
		.tit {
			font-size: 30px;
			color: #F24041;
			text-align: center;
			// margin: 140rpx 0;
			text-align: center;
			padding-top: 50px;
			font-weight: 700;
		}
	
		.loggig {
			width: 320px;
			height: 270px;
			margin: 0 auto;
			padding-top: 20px;
	
			text-align: center;
			display: flex;
		}
	}



// 搜索下拉选择
			.secList{
				    background-color: #fff;
				    border: 1px solid #DCDFE6;
				    border-top: none;
				    border-radius:0 0 4px 4px;
					padding: 10px 0;
					
				.secListli{
					font-size: 15px;
					line-height: 25px;
					display: flex;
					margin: 0 15px;
					color: #9FA2A7;
					cursor: pointer;
					span{
						color: #E72F29;
						margin-left: 5px;
						margin-right: 5px;
					}
				}
				.secListli:hover{
					color: #E72F29;
				}
			}
			.onseleSec{
				color: #000!important;
			}
			
		
</style>